import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ChartComponent } from '../../components/charts/chart.component';
import { Breakpoint, MediaQueryService } from '../../services/media-query.service';
import { TableView, TableViewHelper } from '../../domain/tableview.domain';
import { AssetAllocation } from '../../domain/lti';

import {
  AssetAllocationPieChartService,
  PieValueField,
  TooltipValueField
} from './asset-allocation-pie-chart.service';

@Component({
  selector: 'td-wb-asset-allocation-pie-chart',
  template: '@if (options(); as opts) { <td-wb-chart [options]="opts" /> }',
  imports: [
    ChartComponent
  ]
})
export class AssetAllocationPieChartComponent {
  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly assetAllocationPieChartService = inject(AssetAllocationPieChartService);

  readonly assetAllocations = input<Array<AssetAllocation>>(undefined);
  readonly pieValueField = input<PieValueField>(undefined);
  readonly tooltipValueField = input<TooltipValueField>(undefined);
  readonly tooltipValueFormat = input<string>('n1');
  readonly size = input<number>(undefined);
  readonly innerSize = input<number | string>(undefined);
  readonly animation = input<boolean>(true);

  private readonly breakpointState = toSignal(
    this.mediaQueryService.observe(Breakpoint.MD),
    { initialValue: undefined }
  );

  private readonly view = computed<TableView | undefined>(() => {
    const breakpointState = this.breakpointState();
    return breakpointState === undefined ? undefined : TableViewHelper.fromBreakpoint(breakpointState);
  });

  readonly options = computed<Highcharts.Options | undefined>(() => {
    const view = this.view();
    const assetAllocations = this.assetAllocations();
    if (view === undefined || assetAllocations === undefined) {
      return undefined;
    }

    return this.assetAllocationPieChartService.createChartConfiguration(
      assetAllocations,
      this.pieValueField(),
      this.tooltipValueField(),
      this.tooltipValueFormat(),
      this.getPieSize(view),
      this.innerSize(),
      this.animation()
    );
  });

  private getPieSize(view: TableView): number {
    const size = this.size();
    if (size !== undefined) {
      return size;
    }
    return view === 'table_narrow' ? 200 : 140;
  }
}
